'use strict';

var version = "0.0.0";

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
var dom = videojs.dom || videojs;
var videojsPlayer = videojs.getComponent('Player');
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-annotations-text');
  var handleTimeupdate = function handleTimeupdate() {
    /* get player current time */
    var time = player.currentTime();
    /* check if preview mode for annotation is on */
    if (window.currentVideoAnnotation !== undefined) {
      /* the nth video playing */
      var length = window.currentVideoAnnotation;
      /* cumulate the time for previous videos */
      for (var i = 0; i < length; i++) {
        time += options.videoList[i].end - options.videoList[i].start - options.videoList[i].start;
      }
      /* show / hide annotations text in video player */
      options.annotationsList.forEach(function (item) {
        var annotationEl = document.getElementById('vjs-annotations-text-' + item.id);
        if (item.start <= time && time < item.end && window.currentVideoAnnotation !== undefined) {
          if (!item.content.includes('data:image/')) {
            annotationEl.innerHTML = item.html;
          }
          annotationEl.classList.remove('vjs-hidden');
        } else {
          annotationEl.classList.add('vjs-hidden');
        }
      });
    }
  };
  var handleAnnotationTriggerTime = function handleAnnotationTriggerTime(e, time) {
    console.log(time);
    console.log(e);
    /* check if preview mode for annotation is on */
    if (window.currentVideoAnnotation !== undefined) {
      /* the nth video playing */
      var length = window.currentVideoAnnotation;
      /* cumulate the time for previous videos */
      for (var i = 0; i < length; i++) {
        time += options.videoList[i].end - options.videoList[i].start - options.videoList[i].start;
      }
      /* show / hide annotations text in video player */
      options.annotationsList.forEach(function (item) {
        var annotationEl = document.getElementById('vjs-annotations-text-' + item.id);
        if (item.start <= time && time < item.end && window.currentVideoAnnotation !== undefined) {
          if (!item.content.includes('data:image/')) {
            annotationEl.innerHTML = item.html;
          }
          annotationEl.classList.remove('vjs-hidden');
        } else {
          annotationEl.classList.add('vjs-hidden');
        }
      });
    }
  };

  player.one('timeupdate', handleTimeupdate);
  player.one('annotationTriggerTime', handleAnnotationTriggerTime);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function annotationsText
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var annotationsText = function annotationsText(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    var self = _this;
    console.log("options", options);
    options.annotationsList.forEach(function (item) {
      self.el_.appendChild(createEl(item));
    });
  });
};

function createEl(options) {
  var isImage = false;
  var content = options.content;
  var annnotaion_text = document.getElementById('vjs-annotations-text-' + options.id);
  if (annnotaion_text !== null) {
    document.getElementById('vjs_video_3').removeChild(annnotaion_text);
  }
  var el = dom.createEl('div', {
    className: '\n        vjs-videojs-annotations-text\n        ' + options['class'] + '\n        vjs-hidden\n      '
  });

  el.setAttribute('id', 'vjs-annotations-text-' + options.id);

  if (options.style !== undefined) {
    el.setAttribute('style', options.style);
  }

  if (content.includes('data:image/')) {
    el.style.backgroundImage = 'url(\'' + content + '\')';
    isImage = true;
  } else if (typeof content === 'string' && !isImage) {
    el.innerHTML = options.html;
  } else if (content instanceof window.DocumentFragment) {
    el.appendChild(content);
  } else {
    dom.appendContent(el, content);
  }

  return el;
}
videojsPlayer.prototype.updateAnnotation = function (options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
  var self = this;
  console.log("options", options);
  options.annotationsList.forEach(function (item) {
    self.el_.appendChild(createEl(item));
  });
};
// Register the plugin with video.js.
registerPlugin('annotationsText', annotationsText);

// Include the version number.
annotationsText.VERSION = version;

module.exports = annotationsText;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_annotations_text/dist/videojs-annotations-text.cjs.js
// module id = 569
// module chunks = 1